<template>
  <div>
    <MasterLayout>
      <div class="fuel_consumption_row">
        <div
          class="fuel_consumption_row_right_section tank__bg"
          style="flex: 0 0 96.5%; border-radius: 15px"
          :style="[
            {
              backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.7), rgb(12, 4, 31 , 0.7)), url(${backgroundUrl})`,
              backgroundPosition: 'center',
              backgroundRepeat: 'no-repeat',
              backgroundSize: 'cover',
            },
          ]"
        >
          <div class="row align-items-center" style="height: 100%">
            <div class="col-md-7">
              <div
                class="transaction_period_text text-center branch__sales__text"
                style="font-size: 22px; min-height: 200px"
              >
                <h3 class="our__branches__banner__title">
                  <img src="@/assets/img/tanks_icon.png" class="mr-3" />
                  {{ $t("text.probeTransactions.title") }}
                </h3>
              </div>
            </div>
            <div
              class="row align-items-center justify-content-center col-md-4"
              style="height: 100%"
            >
              <div
                class="col-md-12"
                style="display: flex; justify-content: center"
              >
                <vue-ctk-date-time-picker
                  v-model="dateRange"
                  :max-date="maxDate"
                  :range="true"
                  :autoClose="true"
                  :locale="this.$root.$i18n.locale"
                  :custom-shortcuts="customShortcuts"
                  :color="$store.getters.getDatePickerColor"
                  format="DDMMYYYY"
                  formatted="DD/MM/YYYY"
                  :label="$t('text.calendar.dateRange')"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section-2 mt-3">
        <section>
          <div class="dashboard__table__section mt-3">
            <div class="branch__sales__text_header">
              <div class="row">
                <div class="col-md-8">
                  <span class="sec_text_color">
                    {{ $t("text.probeTransactions.transBetween") }}
                    {{
                      $d(new Date(startDate), "short", this.$root.$i18n.locale)
                    }}
                    {{ $t("text.and.text") }}
                    {{
                      $d(new Date(endDate), "short", this.$root.$i18n.locale)
                    }}
                  </span>
                </div>
                <div class="col-md-4 text-right"></div>
              </div>
              <ejs-grid
                v-show="!showLoader"
                ref="dataGrid"
                :dataBound="dataBound"
                :created="refreshGrid"
                :allowPaging="true"
                :allowSorting="true"
                :pageSettings="pageSettings"
                :toolbar="toolbar"
                :searchSettings="search"
                :allowExcelExport="true"
                :allowPdfExport="true"
                :toolbarClick="toolbarClick"
                :excelQueryCellInfo="excelQueryCellInfo"
                :locale="usedLang"
              >
                <e-columns>
                  <e-column width="80" field="index" headerText="#"></e-column>
                  <e-column
                    field="date"
                    width="180"
                    :format="formatOptions"
                    type="date"
                    :headerText="$t('text.probeTransactions.transDate')"
                  ></e-column>
                  <e-column
                    field="productHeight"
                    format="N2"
                    width="180"
                    :headerText="$t('text.probeTransactions.productHeight')"
                  ></e-column>
                  <e-column
                    field="productVolume"
                    format="N2"
                    width="180"
                    :headerText="$t('text.probeTransactions.productVolume')"
                  ></e-column>
                  <e-column
                    field="temprature"
                    format="N2"
                    width="180"
                    :headerText="$t('text.probeTransactions.temperature')"
                  ></e-column>
                  <e-column
                    field="waterHeight"
                    format="N2"
                    width="180"
                    :headerText="$t('text.probeTransactions.waterHeight')"
                  ></e-column>
                  <e-column
                    field="waterVolume"
                    format="N2"
                    width="180"
                    :headerText="$t('text.probeTransactions.waterVolume')"
                  ></e-column>
                </e-columns>
              </ejs-grid>
              <TableLoader :showLoader="showLoader" />
            </div>
          </div>
        </section>
      </div>
    </MasterLayout>
  </div>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Branch/MasterLayout.vue";
import backgroundUrl from "@/assets/img/Tankimage.png";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import configObject from "@/config";
import TableLoader from "@/components/tableLoader/index";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
  Resize,
  GridPlugin,
  RowDD,
  Selection,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  name: "DashboardHome",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      usedLang: this.$store.getters.getLanguage,
      formatOptions: { type: "date", format: "dd/MM/yyyy hh:mm a" },
      dateRange: {
        start: this.$moment().format("D-M-YYYY"),
        end: this.$moment().format("D-M-YYYY"),
        shortcut: 7,
      },
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      customShortcuts: [
        { key: "Today", label: this.$t("text.calendar.today"), value: "day" },
        {
          key: "yesterday",
          label: this.$t("text.calendar.yesterday"),
          value: "-day",
        },
        {
          key: "last7Days",
          label: this.$t("text.calendar.last7Days"),
          value: 7,
        },
        {
          key: "lastWeek",
          label: this.$t("text.calendar.lastWeek"),
          value: "-isoWeek",
        },
        {
          key: "last30Days",
          label: this.$t("text.calendar.last30Days"),
          value: 30,
        },
        {
          key: "lastMonth",
          label: this.$t("text.calendar.lastMonth"),
          value: "-month",
        },
      ],
      backgroundUrl,
      branch: {},
      branchId: null,
      startDate: this.$moment().format("MMMM D, YYYY"),
      endDate: this.$moment().format("MMMM D, YYYY"),
      pageSettings: { pageSizes: [50, 100, 200], pageCount: 4, pageSize: 50 },
      toolbar: ["ExcelExport", "PdfExport", "Search"],
      search: { operator: "contains", ignoreCase: true },
      branches: 0,
      showLoader: false,
      showAll: false,
    };
  },
  watch: {
    dateRange: function (newRange, oldRange) {
      if (newRange.start !== null && newRange.end !== null) {
        this.startDate = this.$moment(newRange.start, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );
        this.endDate = this.$moment(newRange.end, "DD-MM-YYYY").format(
          "MMMM D, YYYY"
        );

        this.getTankTransaction();
      }
    },
  },
  created() {
    document.title = "Tank Probe Transactions:: Epump Retail Outlet";
    if (localStorage.getItem("userDetails") === "null") {
      this.$router.push({ path: "/" });
    } else if (configObject.authConfig() === null) {
      window.location.reload();
    }
    this.showLoader = true;

    this.$eventHub.$on("branch", (branch) => {
      this.branch = branch;
      document.title = `Tank Probe Transactions:: ${branch.name} Retail Outlet`;
    });
  },
  beforeDestroy() {},
  mounted() {
    if (this.branch.id !== null) {
      this.branchId = this.branch.id;
    }

    if (this.branchId !== null) {
      this.getTankTransaction();
    } else {
    }

    $(".e-input").keyup(function (e) {
      searchFun(e);
    });
    function searchFun(event) {
      var grid = document.getElementsByClassName("e-grid")[0].ej2_instances[0];
      var value = event.target.value;
      grid.search(value);
    }
  },
  methods: {
    excelQueryCellInfo(args) {
      if (args.column.field == "date") {
        args.value = this.$moment(args.value).format("DD/MM/YYYY");
      }
    },
    activateTab(voucher_type) {
      this.activeTab = voucher_type;
    },
    dataBound: function () {
      this.$refs.dataGrid.autoFitColumns();
    },
    // changeRoute(route) {
    //   this.$router.push({ name: route });
    // },
    toolbarClick(args) {
      switch (args.item.text) {
        case "PDF Export":
          this.$refs.dataGrid.pdfExport();
          break;
        case "Excel Export":
          this.$refs.dataGrid.excelExport();
          break;
      }
    },
    refreshGrid() {
      this.$refs.dataGrid.refresh();
    },
    getTankTransaction() {
      this.showLoader = true;
      this.axios
        .get(
          `${configObject.apiBaseUrl}/Tank/ProbeTransactions/${this.$route.params.tankId}/?startDate=${this.startDate}&endDate=${this.endDate}`,
          configObject.authConfig()
        )
        .then((response) => {
          this.showLoader = false;
          response.data.sort((a, b) => {
            if (a.date !== b.date) {
              return a.date > b.date ? -1 : a.date < b.date ? 1 : 0;
            }
          });

          response.data.forEach((cur, index) => {
            cur.index = index + 1;
          });
          this.$refs.dataGrid.ej2Instances.setProperties({
            dataSource: response.data,
          });
          this.refreshGrid();
        })
        .catch((error) => {
          this.showLoader = false;
        });
    },
  },
};
</script>
